import { render, staticRenderFns } from "./EditHighlightsSection.vue?vue&type=template&id=ccf0f154&scoped=true"
import script from "./EditHighlightsSection.vue?vue&type=script&lang=ts"
export * from "./EditHighlightsSection.vue?vue&type=script&lang=ts"
import style0 from "./EditHighlightsSection.vue?vue&type=style&index=0&id=ccf0f154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf0f154",
  null
  
)

export default component.exports